(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1498],{

/***/ 93757:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var OfferIcon = function(param) {
    var _height = param.height, height = _height === void 0 ? 15 : _height, _width = param.width, width = _width === void 0 ? 15 : _width;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M17.236 8.62713L9.244 0.635127C9.07948 0.471113 8.88419 0.341193 8.66934 0.252817C8.4545 0.164442 8.22431 0.11935 7.992 0.120127H1.776C1.30538 0.121446 0.854417 0.308984 0.521638 0.641763C0.188859 0.974542 0.00132197 1.42551 2.59218e-06 1.89613V8.11213C-0.000398322 8.34653 0.0457096 8.57867 0.135656 8.79513C0.225602 9.01158 0.357599 9.20804 0.524002 9.37313L8.516 17.3651C8.68053 17.5291 8.87582 17.6591 9.09066 17.7474C9.30551 17.8358 9.53569 17.8809 9.768 17.8801C10.0012 17.8813 10.2322 17.8356 10.4473 17.7456C10.6624 17.6555 10.8572 17.5231 11.02 17.3561L17.236 11.1401C17.403 10.9773 17.5354 10.7826 17.6254 10.5675C17.7155 10.3524 17.7612 10.1213 17.76 9.88813C17.7584 9.41515 17.5701 8.96195 17.236 8.62713ZM9.768 16.1131L1.776 8.11313V1.89613H7.992V1.88713L15.984 9.87913L9.768 16.1131Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M4.2041 5.32422C4.75639 5.32422 5.2041 4.8765 5.2041 4.32422C5.2041 3.77193 4.75639 3.32422 4.2041 3.32422C3.65182 3.32422 3.2041 3.77193 3.2041 4.32422C3.2041 4.8765 3.65182 5.32422 4.2041 5.32422Z",
                fill: "currentColor"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (OfferIcon);


/***/ }),

/***/ 72084:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ TickFill; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);



function TickFill(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: props.width || 29.25,
        height: props.height || 29.25,
        viewBox: "0 0 29.25 29.25"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M14.625 0A14.625 14.625 0 1029.25 14.625 14.623 14.623 0 0014.625 0zm7.488 10.582l-9.4 9.443h-.008a1.27 1.27 0 01-.816.387 1.231 1.231 0 01-.823-.4l-3.941-3.939a.28.28 0 010-.4l1.256-1.248a.272.272 0 01.394 0l3.122 3.122 8.578-8.641a.278.278 0 01.2-.084.255.255 0 01.2.084l1.23 1.273a.277.277 0 01.008.403z",
            fill: props.color || "#000000"
        })
    }));
}


/***/ }),

/***/ 65700:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var LoaderIcon = function(props) {
    var waterSplashLoader = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "waterSplashLoader",
            style: props.style,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {})
            ]
        });
    };
    var ellipsis = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "ds-ellipsis-loader",
            style: props.style,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {})
            ]
        });
    };
    var _renderLoader = function(type) {
        switch(type){
            case "water_splash_loader":
                return waterSplashLoader();
            case "ellipsis":
            default:
                return ellipsis();
        }
    };
    return _renderLoader(props.type || "");
};
/* harmony default export */ __webpack_exports__["Z"] = (LoaderIcon);


/***/ }),

/***/ 92134:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "OK": function() { return /* binding */ Tab; },
/* harmony export */   "P6": function() { return /* binding */ StripContainer; },
/* harmony export */   "To": function() { return /* binding */ StripIconInfoWrapper; },
/* harmony export */   "YT": function() { return /* binding */ StripOfferIcon; },
/* harmony export */   "iQ": function() { return /* binding */ StripCTA; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var src_utils_getThemeColor__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70758);
/* harmony import */ var src_utils_checkClientDeviceType__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13508);
/* harmony import */ var src_assets_svgExports_OfferIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93757);




var StripOfferIcon = function(param) {
    var _iconSize = param.iconSize, iconSize = _iconSize === void 0 ? null : _iconSize, _customClasses = param.customClasses, customClasses = _customClasses === void 0 ? "" : _customClasses;
    var offerIconSize = iconSize || (src_utils_checkClientDeviceType__WEBPACK_IMPORTED_MODULE_2__/* .IS_DESKTOP */ .yn ? 18 : 14);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: customClasses,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_assets_svgExports_OfferIcon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            height: offerIconSize,
            width: offerIconSize
        })
    });
};
var Tab = function(param) {
    var text = param.text, isActive = param.isActive, onClick = param.onClick, _customClasses = param.customClasses, customClasses = _customClasses === void 0 ? "" : _customClasses;
    var themeColor = (0,src_utils_getThemeColor__WEBPACK_IMPORTED_MODULE_1__/* .getThemeColor */ .p)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        className: "removeGlobalOverride tw-m-0 tw-cursor-pointer tw-border-x-0 tw-border-b-[3px] tw-border-t-0 tw-border-solid tw-bg-transparent tw-px-[12px] tw-pb-[9px] tw-text-[13px]/[20px] ".concat(isActive ? "tw-font-semibold" : "tw-font-medium", " tw-transition-colors tw-duration-500 md:tw-pb-[13px] md:tw-text-[14px]/[20px] ").concat(customClasses),
        onClick: onClick,
        style: {
            borderColor: isActive ? themeColor : "#ffffff",
            color: isActive ? themeColor : "#000000"
        },
        children: text
    });
};
var StripIconInfoWrapper = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "tw-flex tw-gap-[8px] ".concat(props.customClasses || ""),
        children: props.children
    });
};
var StripContainer = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "tw-flex tw-flex-col tw-items-start tw-gap-[8px] tw-border-b tw-border-dashed tw-border-[#EAEAEA]  ".concat(props.showHoverEffect ? "hover:tw-bg-[#F5F5F5]" : "", " md:tw-flex-row md:tw-justify-between md:tw-border-none ").concat(props.customClasses || ""),
        style: {
            backgroundColor: props.bgColor
        },
        onClick: props.onClick,
        children: props.children
    });
};
var StripCTA = function(param) {
    var _ctaTextOrIcon = param.ctaTextOrIcon, ctaTextOrIcon = _ctaTextOrIcon === void 0 ? "Details" : _ctaTextOrIcon, onClick = param.onClick, _customClasses = param.customClasses, customClasses = _customClasses === void 0 ? "" : _customClasses, _isDisabled = param.isDisabled, isDisabled = _isDisabled === void 0 ? false : _isDisabled;
    var themeColor = (0,src_utils_getThemeColor__WEBPACK_IMPORTED_MODULE_1__/* .getThemeColor */ .p)();
    var handleCTAClick = function(e) {
        e === null || e === void 0 ? void 0 : e.stopPropagation();
        onClick();
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        className: "tw-ml-[20px] tw-w-fit ".concat(isDisabled ? "tw-cursor-not-allowed" : "tw-cursor-pointer", " tw-border-none tw-bg-transparent tw-p-0 tw-text-[14px]/[20px] tw-font-semibold md:tw-ml-0 md:tw-text-[16px]/[20px] ").concat(isDisabled ? "tw-opacity-40" : "", " ").concat(customClasses),
        style: {
            color: themeColor
        },
        onClick: handleCTAClick,
        disabled: isDisabled,
        children: ctaTextOrIcon
    });
};


/***/ }),

/***/ 89391:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ CollectionCategoryProductWidget1; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./src/redux/ssrStore.ts + 1 modules
var ssrStore = __webpack_require__(26706);
;// CONCATENATED MODULE: ./src/components/DesignSystem/CollectionCategoryProductWidget/CollectionCategorySideRender.js


var CollectionCategorySideRender = function(param) {
    var collectionCategoryString = param.collectionCategoryString, setAccordionId = param.setAccordionId, categoryClickedToBeScrolled = param.categoryClickedToBeScrolled, scrollToCategory = param.scrollToCategory;
    var collections = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return {
            collections: state.catalogReducer.collections
        };
    }).collections;
    var accordionHeaderClick = function(e) {
        e.stopPropagation();
        var dataId = e.currentTarget.getAttribute("data-id");
        if (Number(dataId) === collectionCategoryString.collectionId) {
            setAccordionId(null);
        } else {
            setAccordionId(Number(dataId));
        }
    };
    var calculateOffsetTop = function() {
        var parentElement = document.getElementsByClassName("preHome-page")[0];
        var header = parentElement === null || parentElement === void 0 ? void 0 : parentElement.firstChild;
        return header ? "".concat((header === null || header === void 0 ? void 0 : header.offsetHeight) + 3, "px") || 0 : 0;
    };
    if ((collections === null || collections === void 0 ? void 0 : collections.length) === 0) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "CollectionCategorySideRender",
        style: {
            top: calculateOffsetTop(),
            overflowY: "scroll",
            maxHeight: "calc(100vh - ".concat(calculateOffsetTop(), " )")
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "collection-accordion",
            children: collections === null || collections === void 0 ? void 0 : collections.map(function(collection) {
                var ref;
                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                    className: "collection-accordion__container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center justify-between collection-accordion__header pointer",
                            "data-id": collection.id,
                            onClick: accordionHeaderClick,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "mv0 tw-max-w-[80%]",
                                    style: {
                                        overflow: "scroll",
                                        scrollbarWidth: "none"
                                    },
                                    children: collection.name
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    alt: "Dropdown button",
                                    style: {
                                        transform: "rotate(".concat(collectionCategoryString.collectionId === collection.id ? "180deg" : "0deg", ")")
                                    },
                                    src: "/assets/images/down-arrow-thin.svg"
                                })
                            ]
                        }),
                        collectionCategoryString.collectionId === collection.id && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "collection-accordion__body",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: "body-list",
                                children: collection === null || collection === void 0 ? void 0 : (ref = collection.categories) === null || ref === void 0 ? void 0 : ref.map(function(category) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        id: category.id,
                                        className: "pointer body-list--item ".concat("".concat(collectionCategoryString.collectionId, "-").concat(collectionCategoryString.categoryId) === "".concat(collection.id, "-").concat(category.id) ? "active" : ""),
                                        onClick: function() {
                                            return scrollToCategory("".concat(collection.id, "-").concat(category.id));
                                        },
                                        children: category.name
                                    }, category.id);
                                })
                            })
                        })
                    ]
                }, collection.id);
            })
        })
    });
};

// EXTERNAL MODULE: ./src/redux/actions/catalog.js
var catalog = __webpack_require__(96031);
// EXTERNAL MODULE: ./src/utils/checkClientDeviceType.js
var checkClientDeviceType = __webpack_require__(13508);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ProductListWrapper/ProductListWrapper.tsx + 2 modules
var ProductListWrapper = __webpack_require__(393);
// EXTERNAL MODULE: ./src/utils/scrollOnPageLoad.js
var scrollOnPageLoad = __webpack_require__(87243);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(13886);
// EXTERNAL MODULE: ./src/components/VirtualisedList/utils.ts
var utils = __webpack_require__(2641);
;// CONCATENATED MODULE: ./src/components/DesignSystem/CollectionCategoryProductWidget/CollectionCategoryProductWidget1.tsx













var CollectionCategoryProductWidget = function() {
    var addCollectionIdCategoryId = function addCollectionIdCategoryId(collectionId, categoryId) {
        var ref, ref1, ref2;
        if (!((ref = prevCollectionIdCategoryId.current) === null || ref === void 0 ? void 0 : (ref1 = ref[collectionId]) === null || ref1 === void 0 ? void 0 : ref1.length)) {
            var ref3;
            prevCollectionIdCategoryId.current[collectionId] = [];
            (ref3 = prevCollectionIdCategoryId.current) === null || ref3 === void 0 ? void 0 : ref3[collectionId].push(categoryId);
            return;
        }
        if ((ref2 = prevCollectionIdCategoryId.current) === null || ref2 === void 0 ? void 0 : ref2[collectionId].find(function(catId) {
            return catId !== categoryId;
        })) {
            var ref4, ref5, ref6;
            if (!((ref4 = prevCollectionIdCategoryId.current) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[collectionId]) === null || ref5 === void 0 ? void 0 : ref5.length)) {
                prevCollectionIdCategoryId.current[collectionId] = [];
            }
            (ref6 = prevCollectionIdCategoryId.current) === null || ref6 === void 0 ? void 0 : ref6[collectionId].push(categoryId);
            return;
        }
        return;
    };
    var checkIfSamePayloadApiAlreadyCalled = function checkIfSamePayloadApiAlreadyCalled(collectionId, categoryId) {
        var ref, ref1, ref2;
        if (!!((ref = prevCollectionIdCategoryId.current) === null || ref === void 0 ? void 0 : (ref1 = ref[collectionId]) === null || ref1 === void 0 ? void 0 : ref1.length) && ((ref2 = prevCollectionIdCategoryId.current) === null || ref2 === void 0 ? void 0 : ref2[collectionId].find(function(catId) {
            return catId === categoryId;
        })) !== undefined) {
            return true;
        }
        return false;
    };
    var dispatch = (0,es/* useDispatch */.I0)();
    var prevCollectionIdCategoryId = (0,react.useRef)({});
    var itemsBodyRef = (0,react.useRef)(null);
    var productListWrapperRef = (0,react.useRef)(null);
    var ref = (0,react.useState)({
        collectionId: null,
        categoryId: null
    }), collectionCategoryActive = ref[0], setCollectionCategoryActive = ref[1];
    (0,react.useEffect)(function() {
        var scrollConfig = (0,scrollOnPageLoad/* scrollOnPageLoad */.l)();
        var timeoutValue = undefined;
        if (scrollConfig === null || scrollConfig === void 0 ? void 0 : scrollConfig.toScroll) {
            try {
                var y_scroll = scrollConfig.y_scroll;
                timeoutValue = setTimeout(function() {
                    sessionStorage.removeItem(constants/* CLICKED_ITEM_OBJ */.uI);
                    window.scrollTo({
                        top: y_scroll
                    });
                }, 1100); // arbitrary number to make sure components are properly rendered before scrolling back to previous scroll
            } catch (err) {
                console.log("timeout time error:", err);
            }
        }
        return function() {
            if (timeoutValue) {
                clearTimeout(timeoutValue);
            }
        };
    }, []);
    (0,react.useLayoutEffect)(function() {
        /**
     * setting scrollBehavior to auto as a smooth scroll will trigger all category API calls
     * lying above the intended category leading to UI stuttering when auto scrolling
     */ document.documentElement.style.scrollBehavior = "auto";
    }, []);
    // This ref keeps track of category that's clicked from left section category list.
    var categoryClickedToBeScrolled = (0,react.useRef)(null);
    var ref1 = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return {
            collections: state.catalogReducer.collections,
            storeData: state.storeReducer.store
        };
    }), collections = ref1.collections, storeData = ref1.storeData;
    var collectionCatalogItems = (0,es/* useSelector */.v9)(function(state) {
        return {
            collectionCatalogItems: state.catalogReducer.collectionCatalogItems
        };
    }).collectionCatalogItems;
    /**
  * function to provide number of skelton to show while products are loading.
  * this is just a random number
  * there is no boundation, you can change this number when required;
  * 9 -> for 3 rows on mobile
  * 8 -> for 4 rows on desktop
  * @returns
  */ var getSkeletonCount = function() {
        return checkClientDeviceType/* IS_DESKTOP */.yn ? 4 : 8;
    };
    /**
   * flattening data such that it can be easily rendered as a virtualised list in `ProductListWrapper`.
   * actual input output and working can be checked from `flattenCollectionCategoryItems`
   */ var flattenedData = (0,react.useMemo)(function() {
        var flattenData = [];
        flattenData = (0,utils/* flattenCollectionCategoryItems */.k)({
            collectionCatalogItems: collectionCatalogItems,
            collections: collections,
            skeletonCardsCount: getSkeletonCount(),
            collectionObject: function(collection) {
                return {
                    id: collection.id,
                    Component: function() {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            "data-id": collection.id,
                            className: "collection-heading",
                            id: "collection-".concat(collection.id),
                            children: collection.name
                        });
                    },
                    type: "component",
                    intersectionCallback: function() {
                        setCollectionCategoryActive(function(prevState) {
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                                collectionId: Number(collection === null || collection === void 0 ? void 0 : collection.id)
                            });
                        });
                    }
                };
            },
            categoryObject: function(collection, category) {
                return {
                    id: "".concat(collection.id, "-").concat(category.id),
                    type: "component",
                    Component: function() {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "category-item-header",
                            children: category.name
                        });
                    },
                    intersectionCallback: function intersectionCallback() {
                        setCollectionCategoryActive(function(prevState) {
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                                categoryId: Number(category === null || category === void 0 ? void 0 : category.id)
                            });
                        });
                        loadMoreData(category, collection);
                    }
                };
            },
            itemObject: function(collection, category, productItem) {
                return {
                    id: "".concat(collection.id, "-").concat(category.id, "-").concat(productItem.id),
                    type: "product-card",
                    data: productItem
                };
            }
        });
        return flattenData;
    }, [
        collections,
        collectionCatalogItems
    ]);
    var loadMoreData = function(category, collection) {
        if ((storeData === null || storeData === void 0 ? void 0 : storeData.store_id) && !checkIfSamePayloadApiAlreadyCalled(collection.id, category.id)) {
            dispatch((0,catalog/* fetchCollectionCatalogItemById */.lA)({
                storeId: storeData.store_id,
                collectionId: collection.id,
                categoryId: category.id
            }));
            addCollectionIdCategoryId(collection.id, category.id);
        }
    };
    var scrollToCategory = function(idToScroll) {
        var ref;
        var indexToScroll = flattenedData === null || flattenedData === void 0 ? void 0 : flattenedData.findIndex(function(dataElement) {
            return (dataElement === null || dataElement === void 0 ? void 0 : dataElement.id) === idToScroll;
        });
        (ref = productListWrapperRef.current) === null || ref === void 0 ? void 0 : ref.scrollToIndex(indexToScroll);
    };
    var setAccordionId = function(id) {
        setCollectionCategoryActive(function(prevState) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                collectionId: id
            });
        });
    };
    var collectionCategoryItemsList = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductListWrapper/* ProductListWrapper */.X, {
            ref: productListWrapperRef,
            renderType: "virtualised-grid",
            productList: flattenedData,
            oldCardConfigs: {
                showButton: true,
                noTags: false
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "CollectionCategoryProductWidget1",
        id: "CollectionCategoryProductWidget",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "CollectionCategoryProductWidget1__body !tw-mb-32",
            children: [
                checkClientDeviceType/* IS_DESKTOP */.yn && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "left-section",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionCategorySideRender, {
                        collectionCategoryString: collectionCategoryActive,
                        setAccordionId: function(id) {
                            return setAccordionId(id);
                        },
                        categoryClickedToBeScrolled: categoryClickedToBeScrolled,
                        scrollToCategory: scrollToCategory
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                    ref: itemsBodyRef,
                    className: "right-section",
                    children: collectionCategoryItemsList()
                })
            ]
        })
    });
};
/* harmony default export */ var CollectionCategoryProductWidget1 = (CollectionCategoryProductWidget);


/***/ }),

/***/ 79220:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ GlobalCfeLoader; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _globalLoader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25480);


var GlobalCfeLoader = function(param) {
    var type = param.type, color = param.color;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_globalLoader__WEBPACK_IMPORTED_MODULE_1__/* .GlobalLoader */ .k, {
        type: type,
        color: color
    });
};


/***/ }),

/***/ 25480:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ GlobalLoader; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _globalLoader_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85134);
/* harmony import */ var _globalLoader_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_globalLoader_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var tailwind_merge__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98388);
/* harmony import */ var src_redux_ssrStore__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26706);
/* harmony import */ var src_components_Common_LoaderIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65700);







var GlobalLoader = function(props) {
    var type = props.type, color = props.color;
    var store = (0,src_redux_ssrStore__WEBPACK_IMPORTED_MODULE_2__/* .useSSRSelector */ .kF)(function(state) {
        return state.storeReducer.store;
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        document.documentElement.style.setProperty("--loader-color", color);
    }, [
        color
    ]);
    switch(type){
        case "logo1":
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_4__/* .twMerge */ .m6)((_globalLoader_module_scss__WEBPACK_IMPORTED_MODULE_5___default().logo1)),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: store.logo_image,
                        style: {
                            height: "35px",
                            width: "35px"
                        }
                    })
                });
            }
        case "logo2":
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_4__/* .twMerge */ .m6)((_globalLoader_module_scss__WEBPACK_IMPORTED_MODULE_5___default().logo2)),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: store.logo_image,
                        style: {
                            height: "35px",
                            width: "35px"
                        }
                    })
                });
            }
        case "loader1":
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                    version: "1.1",
                    id: "L9",
                    xmlns: "http://www.w3.org/2000/svg",
                    x: "0px",
                    y: "0px",
                    width: "65px",
                    height: "65px",
                    viewBox: "0 0 100 100",
                    enableBackground: "new 0 0 0 0",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fill: color,
                        d: "M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("animateTransform", {
                            attributeName: "transform",
                            attributeType: "XML",
                            type: "rotate",
                            dur: "1s",
                            from: "0 50 50",
                            to: "360 50 50",
                            repeatCount: "indefinite"
                        })
                    })
                });
            }
        case "loader2":
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                    version: "1.1",
                    id: "L5",
                    xmlns: "http://www.w3.org/2000/svg",
                    x: "0px",
                    y: "0px",
                    width: "35px",
                    height: "35px",
                    viewBox: "-20 0 100 100",
                    enableBackground: "new 0 0 0 0",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            fill: color,
                            stroke: "none",
                            cx: "6",
                            cy: "50",
                            r: "6",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("animateTransform", {
                                attributeName: "transform",
                                dur: "1s",
                                type: "translate",
                                values: "0 15 ; 0 -15; 0 15",
                                repeatCount: "indefinite",
                                begin: "0.1"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            fill: color,
                            stroke: "none",
                            cx: "30",
                            cy: "50",
                            r: "6",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("animateTransform", {
                                attributeName: "transform",
                                dur: "1s",
                                type: "translate",
                                values: "0 10 ; 0 -10; 0 10",
                                repeatCount: "indefinite",
                                begin: "0.2"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            fill: color,
                            stroke: "none",
                            cx: "54",
                            cy: "50",
                            r: "6",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("animateTransform", {
                                attributeName: "transform",
                                dur: "1s",
                                type: "translate",
                                values: "0 5 ; 0 -5; 0 5",
                                repeatCount: "indefinite",
                                begin: "0.3"
                            })
                        })
                    ]
                });
            }
        case "loader3":
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_4__/* .twMerge */ .m6)((_globalLoader_module_scss__WEBPACK_IMPORTED_MODULE_5___default().loader3), "tw-h-[35px] tw-w-[35px]")
                });
            }
        case "loader4":
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                    version: "1.1",
                    id: "L4",
                    xmlns: "http://www.w3.org/2000/svg",
                    x: "0px",
                    y: "0px",
                    width: "35px",
                    height: "35px",
                    viewBox: "-20 0 100 100",
                    enableBackground: "new 0 0 0 0",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            fill: color,
                            stroke: "none",
                            cx: "6",
                            cy: "50",
                            r: "6",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("animate", {
                                attributeName: "opacity",
                                dur: "1s",
                                values: "0;1;0",
                                repeatCount: "indefinite",
                                begin: "0.1"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            fill: color,
                            stroke: "none",
                            cx: "26",
                            cy: "50",
                            r: "6",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("animate", {
                                attributeName: "opacity",
                                dur: "1s",
                                values: "0;1;0",
                                repeatCount: "indefinite",
                                begin: "0.2"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            fill: color,
                            stroke: "none",
                            cx: "46",
                            cy: "50",
                            r: "6",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("animate", {
                                attributeName: "opacity",
                                dur: "1s",
                                values: "0;1;0",
                                repeatCount: "indefinite",
                                begin: "0.3"
                            })
                        })
                    ]
                });
            }
        case "loader5":
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_4__/* .twMerge */ .m6)((_globalLoader_module_scss__WEBPACK_IMPORTED_MODULE_5___default().loader5), "tw-h-[16px] tw-w-[35px]")
                });
            }
        default:
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_Common_LoaderIcon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, props));
            }
    }
};


/***/ }),

/***/ 10445:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ PROMO_APPLICABILITY_TYPES; }
/* harmony export */ });
/* unused harmony export PROMO_TYPES */
var PROMO_TYPES = {
    GENERAL: 1,
    PRODUCT: 2,
    TAG: 3,
    CATEGORY: 4,
    COLLECTION: 5,
    BUYXGETY: 6
};
var PROMO_APPLICABILITY_TYPES = {
    PRODUCT: 1,
    TAG: 2,
    CATEGORY: 3,
    COLLECTION: 4
};


/***/ }),

/***/ 85134:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"logo1":"globalLoader_logo1__U4pxQ","logo-1":"globalLoader_logo-1__07zYZ","logo2":"globalLoader_logo2__eivVl","loader-3":"globalLoader_loader-3__8hklP","loader3":"globalLoader_loader3__m47Bj","loader5":"globalLoader_loader5__6NXRf","loader-5-1":"globalLoader_loader-5-1__pESNT","loader-5-2":"globalLoader_loader-5-2__VgxuZ"};

/***/ })

}]);